import * as React from "react";
import Grid from "@mui/material/Grid";
import {
  Card,
  CardActions,
  CardMedia,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import img from "../../assets/img/porta.png";
import { connect, useDispatch, useSelector } from "react-redux";
import DropMenu from "../../components/DropMenu/dropMenu";
import CustomizedSnackbars from "../../components/Message/Snackars";
import { useEffect, useState } from "react";
import { importBaseActions } from "../../store/reducers/base";
import { useNavigate } from "react-router-dom";
import { formatDate, getProductName } from "../../Utility";
import { useConfigurationsService } from "../../v2/services/configurations_service";
import { useStoreDispatch } from "../../hooks/StoreHooks";
import { useDoorConfigurationBuilderActions } from "../../store/reducers/door_configuration_builder";
import { getCurrentUser } from "../../v2/core/common_functions";
import { CategoryCode } from "../../v2/models/door_configuration";
import clientiArchiviati from "./clientiArchiviati";

const CartellaPreventivi = ({ data }) => {
  const state = useSelector(state => state.base);
  const dispatch = useDispatch();
  const dispatcher = useStoreDispatch();
  const baseActions = importBaseActions();
  const configurationService = useConfigurationsService();
  const currentUser = getCurrentUser(state);
  const {setConfiguration} = useDoorConfigurationBuilderActions();
  //const history = useHistory();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const handleClick = () => setOpen(true);
  let axiosConfig = {
    headers: {
      Authorization: "Bearer " + state.user.token,
    },
  };

  const getProductTitle = (res) => {
    let productName = getProductName(res.category_id);
    if (res.custom_client_name) {
      productName += ` - ${res.custom_client_name}`;
    }
    return productName;
  }

  const loadConfiguration = async (configurationId) => {
    try {
      let configuration = await configurationService.loadDoorConfiguration(currentUser, configurationId);

      dispatcher(setConfiguration(configuration));

      if (configuration.isFinito) {
        navigate("/generaPDF");
      } else {
        if (configuration.categoryCode == "PORTA_SEZIONALE"/*CategoryCode.PortaSezionale*/) {
          
        }
      }
    } catch (e) {
      console.log(e);
      // setLoading({isActive: false, error: e.message});
    }
  }
  const nameClient = {
    fontSize: "16px",
    fontStyle: 'italic',
    color: "#000",
    marginBottom: "0.9rem"
  }
  const renderBadge = (item) => {
    const text = `#${item.id} ${getProductTitle(item)}`;

    if ("finished" == item.sync_status) {
      return (
        <span className="badge bg-success">{text}</span>
      );
    } 
    
    if (!item.category_id || Number(item.category_id) <= 0 ) {
      return (
        <span className="badge bg-danger">{text}</span>
      );  
    } 

    return (
      <span className={"badge bg-warning text-dark"}>{text}</span>
    );
  }
  const stateConfig = (item) => {
    const text = ` ${getProductTitle(item)}`;

      if ("completed" == item.status) {
        return (
          <span className="badge bg-success">Completato</span>
        );
      } 
      if ("order_confirmed" == item.status || "order_sent" == item.status) {
        return (
          <span className="badge bg-success">Completato e Confermato</span>
        );
      } 
      if (!item.category_id || Number(item.category_id) <= 0 ) {
        return (
          <span className="badge bg-danger ">Prodotto non selezionato</span>
        );
      } 

      return (
        <span className="badge bg-warning text-dark">In Corso</span>
      );
    }
    
  useEffect(() => {
    console.log(data)
    // count.success === true && handleClick();
    // dispatch.count.setSuccess(false);
  }, []);

  return (
    <>
      <div className="px-3">
        {data.map((res, index) => (
        <div className="col-12 mb-3" key={index}>
          <div className="card rounded-3 card-quote" onClick={() => {
            debugger;        
            dispatch(baseActions.clearStorage());
            dispatch(baseActions.setQuoteId(res.id));
            dispatch(baseActions.setIdPorta(res.category_id));
            if (!res.category_id || Number(res.category_id) <= 0) {
              navigate("/products", {state: {id: res.customer_id}});
            } else {
              debugger
              if (res.category_id != 1/*SEZIONALE*/) {
                if (res.sync_status == "finished" && res.category_id != 4) {
                  navigate("/generaPDF");
                } else {
                  if(res.category_id == 4){
                    navigate(`/pergola-configurations/${res.id}`)
                  }else if(res.category_id == 2){
                    navigate(`/overlap-configurations/${res.id}`);
                  }else{
                    navigate(`/overbas-configurations/${res.id}`);
                  }
                }
              } else {
                navigate(`/door-configurations/${res.id}`);
              }
            }
          }} style={{position: "relative", marginBottom: "15px"}}>
                <div
                  className="d-flex flex-column flex-lg-row p-2 justify-content-between"
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex flex-column flex-lg-row align-items-center align-items-lg-start text-center text-lg-start">
                    <div className="p-2 d-flex justify-content-center">
                      <img
                        src={res.preview || res.urlPreview || img}
                        className="card-img-top"
                        style={{ maxWidth: "170px", height: "auto" }}
                      />
                    </div>
                    <div className="d-flex flex-column p-2">
                      <span className="numb">
                        #{res.id}
                        {res.custom_client_name && (
                          <span> - {res.custom_client_name}</span>
                        )}
                      </span>
                      <div
                        className="d-flex align-items-center justify-content-center justify-content-lg-start flex-wrap"
                        style={{ gap: ".5rem" }}
                      >
                        <span
                          className="badge text-white fw-normal"
                          style={{
                            textTransform: "lowercase",
                            fontSize: ".75rem",
                            backgroundColor: "#df5b23",
                          }}
                        >
                          {formatDate(res.created_at)}
                        </span>
                        {stateConfig(res)}
                      </div>
                      <span className="mt-2">
                        {res.category_id === 1
                          ? "Sezionale"
                          : res.category_id === 2
                          ? "Overlap"
                          : res.category_id === 3
                          ? "OverBas"
                          : res.category_id == 4
                          ? "Pergola"
                          : ""}
                      </span>
                      {res.created_by?.trim() && (
                        <span className="mt-2" style={{ fontSize: ".65rem" }}>
                          Creato da {res.created_by}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="d-none d-lg-flex justify-content-center align-items-center">
                    <ChevronRightIcon />
                  </div>
                </div>
              </div>
            </div>
        ))}
        <CustomizedSnackbars open={open} setOpen={setOpen} />
      </div>
    </>
  );
};

export default CartellaPreventivi;